window.neptune = window.neptune || {};
window.neptune.donation = {
  isRefeshing: false,
  variantId:0,
  routes: {
    add: "/cart/add.js",
    change: "/cart/change.js"
  },
  
  init: function () {
    return new Promise((resolve) => {
      var currency = window.Shopify.currency.active == "GBP" ? "£" : " €";
      fetch("/products/stump-up-for-trees-donation.json")
        .then((g) => g.json())
        .then((result) => {

          this.variantId = result.product.variants[0].id;
          const suftName = document.querySelector(".js-suft-name");
          if (suftName) suftName.innerHTML = result.product.title;
          
          const suftImg = document.querySelector(".js-suft-img");
          if (suftImg) suftImg.src = result.product.images[0].src;
          
          var priceDiv = document.querySelector(".js-suft-price");
          var totalInput = document.querySelector(".js-suft-total");

          fetch("/cart.js")
            .then((response) => response.json())
            .then((data) => {
              var inBasket = data.items.filter(
                (e) => e.title.toLowerCase().indexOf("stump up for trees") != -1
              );

              if (inBasket.length > 0) {
                const cartIdEl = document.querySelector("[data-suft-js-cart-id]");
                if (cartIdEl) cartIdEl.setAttribute("data-suft-js-cart-id", inBasket[0].key);
                if (priceDiv) priceDiv.innerHTML = currency + ((result.product.variants[0].price) * inBasket[0].quantity);
                if (totalInput) totalInput.value = inBasket[0].quantity;
              } else {
                if (totalInput) totalInput.value = 0;
                if (priceDiv) priceDiv.innerHTML = currency + "0.00";
              }
              resolve();
            });
        }).catch(e => {
          console.warn('Donation init fetch failed:', e);
          resolve();
        });
    });
  },
  change: function (direction) {
    var loading = document.querySelector(".cart-template__loading");
    var suftTotal = document.querySelector(".js-suft-total");
    if (loading) loading.classList.add("is-active");

    var currentQty = parseInt(suftTotal.value) || 0;
    var data = {
      quantity: 1,
      id: this.variantId,
    }

    var path = window.neptune.donation.routes.add;

    if (direction == "+") {
      data.quantity = currentQty + 1;
      if (currentQty === 0) {
        path = window.neptune.donation.routes.add;
      } else {
        path = window.neptune.donation.routes.change;
      }
    } else if (direction == "-") {
      data.quantity = Math.max(0, currentQty - 1);
      path = window.neptune.donation.routes.change;
    }

    // If using change.js, we should use the line item key if available
    const cartIdEl = document.querySelector("[data-suft-js-cart-id]");
    const cartKey = cartIdEl ? cartIdEl.getAttribute("data-suft-js-cart-id") : '';
    if (cartKey && path === window.neptune.donation.routes.change) {
      data.id = cartKey;
    }


    fetch(path, {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
      },
      redirect: "follow",
      referrerPolicy: "no-referrer",
      body: JSON.stringify(data),
    }).then(e => e.text()).then(y => {
      if (window.cartAPI && window.cartAPI.refreshDrawer) {
          window.cartAPI.refreshDrawer().then(() => {
              window.neptune.donation.init();
          });
      } else {
          if (loading) loading.classList.remove("is-active");
          window.neptune.donation.init();
      }
    })
  }
};

class NeptuneDonation extends HTMLElement {
  connectedCallback() {
    this.initDonation();
  }

  initDonation() {
    if (window.neptune && window.neptune.donation && typeof window.neptune.donation.init === 'function') {
      window.neptune.donation.init();
    } else {
      setTimeout(() => this.initDonation(), 100);
    }
  }
}

customElements.define('neptune-donation', NeptuneDonation);
